module.exports = __webpack_public_path__ + "img/tijdstructurering.2549acfd.png";